import { Notify } from 'quasar';
import { captureMessage } from '@sentry/vue';
import { isProd } from '@/config/env.ts';

/**
 * After a deploy, a tab still open on the previous release requests chunk filenames that no
 * longer exist. Preventing the default of vite:preloadError (below) makes the lazy route import
 * resolve to undefined, and vue-router then fails with this message. The user already sees the
 * new-version notification, so the error is noise. Vite checks route imports at build time, so
 * a stale chunk is the only cause while every lazy route returns its module unchanged. A loader
 * that picks a named export (`.then((m) => m.Named)`) would fail with this message too, unseen.
 */
export const UNRESOLVED_ROUTE_COMPONENT_ERROR = /Couldn't resolve component/;

export function setupErrorHandling() {
  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault();

    Notify.create({
      message:
        'A new version of the application is now available. Please save any unsaved work before reloading the page to access the latest version.',
      color: 'red',
      timeout: 0,
      position: 'top',
      actions: [
        {
          label: 'Refresh',
          color: 'white',
          handler: () => {
            if (isProd) {
              captureMessage('Refresh button clicked. vite:preloadError');
            }
            window.location.reload();
          },
        },
        {
          icon: 'close',
          color: 'white',
          handler: () => {
            if (!isProd) return;
            captureMessage('Close button clicked. vite:preloadError');
          },
        },
      ],
      ignoreDefaults: true,
    });
  });
}
